import { ENV } from './env';

/**
 * Validate Firebase configuration object
 * @param {Object} config - Firebase configuration object
 * @throws {Error} If configuration is invalid
 */
const validateFirebaseConfig = (config) => {
  const requiredFields = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
  const missingFields = [];
  
  requiredFields.forEach(field => {
    if (!config[field] || config[field].trim() === '') {
      missingFields.push(field);
    }
  });
  
  if (missingFields.length > 0) {
    throw new Error(`
❌ Invalid Firebase configuration:

Missing or empty fields:
${missingFields.map(field => `  - ${field}`).join('\n')}

Please check your environment variables and ensure all Firebase configuration values are properly set.
    `.trim());
  }
};

// Create Firebase configuration object
const createFirebaseConfig = () => {
  const config = {
    apiKey: ENV.FIREBASE_API_KEY,
    authDomain: ENV.FIREBASE_AUTH_DOMAIN,
    projectId: ENV.FIREBASE_PROJECT_ID,
    storageBucket: ENV.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: ENV.FIREBASE_MESSAGING_SENDER_ID,
    appId: ENV.FIREBASE_APP_ID,
  };

  // API'ye gecis surecinde Firebase anahtarlari olmayabilir.
  // Eksikse UI'yi cokertmek yerine sadece uyar; Firebase'e bagli (henuz
  // gocmeyen) sayfalar acilinca calismaz, ama login + events (API) calisir.
  try {
    validateFirebaseConfig(config);
  } catch (error) {
    console.warn(
      'Firebase yapilandirmasi eksik - Firebase tabanli kaynaklar devre disi olabilir.',
      error.message,
    );
  }

  return config;
};

// Export validated Firebase configuration
export const FirebaseConfig = createFirebaseConfig();

// Firebase options with environment-based configuration
export const FirebaseOptions = {
  // Enable lazy loading in development for better performance
  lazyLoading: {
    enabled: ENV.ENVIRONMENT === 'development'
  },
  
  // Enable debug logging in development
  debug: ENV.DEBUG === 'true',
  
  // Additional options can be added here based on environment
  ...(ENV.ENVIRONMENT === 'production' && {
    // Production-specific options
    persistence: 'local',
  }),
};

// Export validation function for testing
export { validateFirebaseConfig };
